import React, { FC, useId, useState, useEffect } from "react"

type option = {
  name: string,
  onClick?: () => void,
  options?: option[],
}

type Props = {
  options: option[] | string,
  openOnLeftClick?: boolean,
  openOnRightClick?: boolean,
  children?: any
}
/**
 * A Popover container over a children element. When clicked, a list of `options` will be displayed.
 * @param options An array of {name, onClick, options} to be displayed then the Popover is clicked.
 * @param openOnLeftClick Should the popover be opened with left click? Default is `true`
 * @param openOnRightClick Should the popover be opened with right click? Default is `false`
 * @returns 
 */
const Popover: FC<Props> = ({ options, openOnLeftClick, openOnRightClick, children }) => {
  const [isShown, setIsShown] = useState(false)
  const id = useId()
  openOnLeftClick = openOnLeftClick ?? typeof options === "object";

  const popoverDefocus = (e: MouseEvent) => {
    const popoverElement = document.getElementById(id);
    const clickedElement = e.target

    if (!clickedElement || !popoverElement) return
    else if (popoverElement?.classList.contains("hidden")) return
    else if (!popoverElement.contains(clickedElement as Node)) setIsShown(false)
  }

  useEffect(() => {
    document.addEventListener("click", popoverDefocus)
    return function removePopoverDefocus() {
      document.removeEventListener("click", popoverDefocus)
    }
  }, [])

  const getOptions = (options: option[]) => {
    return options.map((o, i) => {
      return <li key={i}>
        <button type="button" className='z-20 schipt-btn secondary' onClick={() => {
          setIsShown(false)
          o.onClick?.()
        }} >{o.name}</button>
      </li>
    })
  }

  return <div id={id} className={`testing relative w-fit popover-container`}
    onClick={() => {
      if (!openOnLeftClick) return
      setIsShown(i => !i)
    }}
    onContextMenu={(e) => {
      if (!openOnRightClick) return
      e.preventDefault()
      e.stopPropagation()
      setIsShown(i => !i)
    }}
    title={typeof options === "string" ? options : undefined}
  >
    {children}
    <div className={`popover-menu ${isShown ? "" : "hidden"} p-2 right-0 top-[20px] absolute w-m-[120px] z-10 bg-schipt-white dark:bg-schipt-darkest border shadow-md`}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}      
    >
      {typeof options === "string" ? <></> :
        <ul className='flex flex-col'>
          {getOptions(options)}
        </ul>
      }      
    </div>
  </div>

}

export default Popover